import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-link\"><defs><style type=\"text/css\"></style></defs><path d=\"M912 1008.512H15.488V112h448.256v96H111.488v704.512H816V560.256h96z\" p-id=\"2942\" /><path d=\"M918.208 37.888l67.904 67.904L545.984 545.92 478.08 478.08z\" p-id=\"2943\" /><path d=\"M1007.168 310.656h-96V112h-208V16h304z\" p-id=\"2944\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol